/* @ngInject */
const metadata = (
  ownerFields,
  ownerButtons
) => {
  const self = {}

  self.favoriteSort = ['society',]

  self.buttons = [
    ownerButtons.search,
    ownerButtons.edit,
    ownerButtons.delete,
  ]

  self.fields = ownerFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/metadata.service.js